import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, AlertTriangle } from "lucide-react";
import api from "@/lib/api";
import { useCart } from "@/context/CartContext";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState("checking");
  const { clear } = useCart();

  useEffect(() => {
    if (state === "paid") clear();
  }, [state, clear]);

  useEffect(() => {
    if (!sessionId) {
      setState("error");
      return;
    }
    let attempts = 0;
    let timer;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setState("paid");
          return;
        }      } catch {}
      attempts += 1;
      if (attempts < 12) {
        timer = setTimeout(poll, 2000);
      } else {
        setState("timeout");
      }
    };
    poll();
    return () => clearTimeout(timer);
  }, [sessionId]);

  return (
    <div data-testid="payment-success-page" className="hero-grid flex min-h-[70vh] items-center justify-center px-4 py-16">
      <div className="card-tactical glow-orange w-full max-w-md p-8 text-center">
        {state === "checking" && (
          <>
            <Loader2 className="mx-auto h-14 w-14 animate-spin text-orange-500" />
            <h1 className="mt-4 text-2xl font-extrabold uppercase">Vérification du paiement...</h1>
            <p className="mt-2 text-sm text-slate-400">Merci de patienter quelques secondes.</p>
          </>
        )}
        {state === "paid" && (
          <>
            <CheckCircle2 className="mx-auto h-14 w-14 text-emerald-400" />
            <h1 className="mt-4 text-2xl font-extrabold uppercase" data-testid="payment-confirmed-title">Paiement confirmé !</h1>
            <p className="mt-3 text-sm leading-relaxed text-slate-300">
              Merci pour votre commande et votre soutien à Emisphere Esport !
              Votre maillot sera préparé par l'équipe et vous recevrez un email de suivi.
            </p>
          </>
        )}
        {(state === "timeout" || state === "error") && (
          <>
            <AlertTriangle className="mx-auto h-14 w-14 text-orange-400" />
            <h1 className="mt-4 text-2xl font-extrabold uppercase">Vérification en cours</h1>
            <p className="mt-3 text-sm leading-relaxed text-slate-300">
              La confirmation prend plus de temps que prévu. Si vous avez été débité,
              votre commande est bien enregistrée — contactez-nous en cas de question.
            </p>
          </>
        )}
        <Link to="/" data-testid="payment-success-home-link"
          className="mt-8 inline-block rounded-xl bg-orange-500 px-6 py-3 font-heading text-lg font-bold uppercase tracking-wide text-[#060B18] transition-all hover:scale-[1.02] hover:bg-orange-400 active:scale-[0.98]">
          Retour à l'accueil
        </Link>
      </div>
    </div>
  );
}
